import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

function EmptyState({ message, description, ctaLabel, ctaTo }) {
  return (
    <div className="empty-state">
      <h4>{message}</h4>
      {description && <p>{description}</p>}
      {ctaLabel && ctaTo && (
        <LinkContainer exact to={ctaTo}>
          <Button>{ctaLabel}</Button>
        </LinkContainer>
      )}
    </div>
  );
}

export { EmptyState };
